// Дээд цэсний горимд: одоогийн хуудас аль бүлэгт байна, тэр бүлгийн бүх хуудсыг дэд мөрөнд таб шиг харуулна.
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAccess } from "contexts/access";
import menu, { filterMenu, keyForPath } from "../menu";

export default function SubNav() {
  const { can, loading } = useAccess();
  const location = useLocation();
  if (loading) return null;
  const key = keyForPath(location.pathname);
  const group = filterMenu(menu, can).find((g) => g.children?.some((c) => c.key === key));
  if (!group || group.children.length < 2) return null;
  return (
    <nav aria-label={group.label} className="sub-nav">
      <span className="sub-nav-title">{group.label}</span>
      {group.children.map((c) => (
        <Link key={c.key} to={c.to} aria-current={c.key === key ? "page" : undefined} className={`sub-nav-item ${c.key === key ? "on" : ""}`}>
          {c.icon}<span>{c.label?.props?.children}</span>
        </Link>
      ))}
    </nav>
  );
}
